<template>
  <div class="create-guarantee-info">
    <MyTitle theTitle="担保信息" isSubmit="已提交" />
    <div class="fd-com-scroll" ref="element">
      <van-cell-group>
        <info-title title-content="担保基本信息" vertical-line="true" />
        <div class="guarantee-basic-info">
          <div class="guarantee-basic-info-inner">
            <van-row>
              <van-col span="9" class="col-key" align="right">申请法院</van-col>
              <van-col span="13" class="col-value" offset="2">{{
                basicData.cFymc
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">担保机构</van-col>
              <van-col
                span="13"
                class="col-value"
                offset="2"
                @click="toast(basicData.cBxgsmc)"
                >{{ basicData.cBxgsmc }}</van-col
              >
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">保全类型</van-col>
              <van-col span="13" class="col-value" offset="2">{{
                basicData.cBqlxText
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">保全类别</van-col>
              <van-col span="13" class="col-value" offset="2">{{
                basicData.cBqlbText
              }}</van-col>
            </van-row>
            <van-row v-if="basicData.cBqlb == 1">
              <van-col span="9" class="col-key" align="right">非诉期间</van-col>
              <van-col
                span="13"
                class="col-value"
                offset="2"
                @click="toast(basicData.cFsqjText)"
                >{{ basicData.cFsqjText }}</van-col
              >
            </van-row>
            <!--诉讼保全显示案件信息-->
            <template v-if="basicData.cBqlb == 2">
              <van-row>
                <van-col span="9" class="col-key" align="right"
                  >案件类型</van-col
                >
                <van-col span="13" class="col-value" offset="2">{{
                  formData.nAjlxText
                }}</van-col>
              </van-row>
              <van-row>
                <van-col span="9" class="col-key" align="right">案号</van-col>
                <van-col
                  span="13"
                  class="col-value"
                  offset="2"
                  @click="toast(formData.cAh)"
                  >{{ formData.cAh }}</van-col
                >
              </van-row>
              <!--<van-row>
                                <van-col span="9" class="col-key" align="right">{{formData.nAjlx == 6?'案由(主体类型)': '案由'}}</van-col>
                                <van-col span="13" class="col-value" offset="2" @click="toast(formData.cAyName)">{{formData.cAyName}}</van-col>
                            </van-row>
                            <van-row v-if="formData.nAjlx == 6">
                                <van-col span="9" class="col-key" align="right">案由(行为种类)</van-col>
                                <van-col span="13" class="col-value" offset="2" @click="toast(formData.cAyxzxwName)">{{formData.cAyxzxwName}}</van-col>
                            </van-row>-->
              <!--<van-row v-if="(formData.nAjlx == 1 || formData.nAjlx == 2)">
                                <van-col span="9" class="col-key" align="right">案由</van-col>
                                <van-col span="13" class="col-value" offset="2" @click="toast(formData.cAyName)">{{formData.cAyName}}</van-col>
                            </van-row>-->
              <van-row v-if="formData.nAjlx == 6">
                <van-col span="9" class="col-key" align="right">{{
                  ayLabel_1
                }}</van-col>
                <van-col
                  span="13"
                  class="col-value"
                  offset="2"
                  @click="toast(formData.cAyName)"
                  >{{ formData.cAyName }}</van-col
                >
              </van-row>
              <van-row v-if="formData.nAjlx == 6 && basicData.cAyxzxwName">
                <van-col span="9" class="col-key" align="right">{{
                  ayLabel_2
                }}</van-col>
                <van-col
                  span="13"
                  class="col-value"
                  offset="2"
                  @click="toast(basicData.cAyxzxwName)"
                  >{{ basicData.cAyxzxwName }}</van-col
                >
              </van-row>
              <van-row v-if="formData.nAjlx == 6 && formData.cAhNf >= 2021">
                <van-col span="9" class="col-key" align="right"
                  >行政案由名称</van-col
                >
                <van-col
                  span="13"
                  class="col-value"
                  offset="2"
                  @click="toast(formData.cXzaymc)"
                  >{{ formData.cXzaymc }}</van-col
                >
              </van-row>
            </template>
            <van-row>
              <van-col span="9" class="col-key" align="right"
                >申请担保金额</van-col
              >
              <van-col span="13" class="col-value" offset="2"
                >{{ basicData.nSqbqje }} 元</van-col
              >
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right"
                >建议担保费</van-col
              >
              <van-col span="13" class="col-value" offset="2">
                {{ basicData.nDbfy }} 元</van-col
              >
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">费率</van-col>
              <van-col span="13" class="col-value" offset="2">
                {{ basicData.cFl * 1000 }}‰</van-col
              >
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">提交人</van-col>
              <van-col span="13" class="col-value" offset="2">{{
                basicData.cTjr
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right"
                >提交人身份</van-col
              >
              <van-col span="13" class="col-value" offset="2">{{
                basicData.cTjrlxText
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right">提交日期</van-col>
              <van-col span="13" class="col-value" offset="2">{{
                basicData.dtTjsj
              }}</van-col>
            </van-row>
            <van-row>
              <van-col span="9" class="col-key" align="right"
                >咨询员编号</van-col
              >
              <van-col
                span="13"
                class="col-value"
                offset="2"
                @click="toast(basicData.cClerkNo)"
                >{{ basicData.cClerkNo }}</van-col
              >
            </van-row>
          </div>
        </div>
        <info-title
          title-content="申请人"
          required-description="必填"
          vertical-line="true"
        >
          <template slot="icon">
            <van-icon
              slot="right-icon"
              name="plus"
              style="line-height: inherit; float: right"
              @click="goToSQR()"
            ></van-icon>
          </template>
        </info-title>
        <van-swipe-cell v-for="(item, index) in sqrData" :key="item.cId">
          <van-cell
            :title="item.cSqrxm"
            :value="item.cSqrlx"
            @click="goToSQR(item.cId)"
            is-link
          />
          <template slot="right">
            <div class="delete-btn" @click="deleteSQR(item.cId, index)">
              删除
            </div>
          </template>
        </van-swipe-cell>
        <info-title
          title-content="被申请人"
          required-description="必填"
          vertical-line="true"
        >
          <template slot="icon">
            <van-icon
              slot="right-icon"
              name="plus"
              style="line-height: inherit; float: right"
              @click="goToAddBSQR()"
            ></van-icon>
          </template>
        </info-title>
        <van-swipe-cell v-for="(item, index) in bsqrData" :key="item.cDbDsrid">
          <van-cell
            :title="item.cDsrxm"
            :value="item.cDsrlxText"
            @click="goToAddBSQR(item.cDbDsrid)"
            is-link
          />
          <template slot="right">
            <div class="delete-btn" @click="deleteBSQR(item.cDbDsrid, index)">
              删除
            </div>
          </template>
        </van-swipe-cell>
        <info-title title-content="原告代理人" vertical-line="true">
          <template slot="icon">
            <van-icon
              slot="right-icon"
              name="plus"
              style="line-height: inherit; float: right"
              @click="goToAddYGDLR()"
            ></van-icon>
          </template>
        </info-title>
        <van-swipe-cell v-for="(item, index) in dlrData" :key="item.cId">
          <van-cell
            :title="item.dlrmc"
            value=""
            @click="goToAddYGDLR(item.cId)"
            is-link
          />
          <template slot="right">
            <div class="delete-btn" @click="deleteYGDLR(item.cId, index)">
              删除
            </div>
          </template>
        </van-swipe-cell>
        <info-title
          title-content="财产线索"
          required-description="必填"
          vertical-line="true"
        >
          <template slot="icon">
            <van-icon
              slot="right-icon"
              name="plus"
              style="line-height: inherit; float: right"
              @click="goToAddCCXS()"
            ></van-icon>
          </template>
        </info-title>
        <van-swipe-cell v-for="(item, index) in ccxsData" :key="item.cDbppid">
          <van-cell
            :title="item.ccxsmc"
            :value="item.cSqbqccjeText"
            @click="goToAddCCXS(item.cDbppid)"
            is-link
          ></van-cell>
          <template slot="right">
            <div class="delete-btn" @click="deleteCCXS(item.cDbppid, index)">
              删除
            </div>
          </template>
        </van-swipe-cell>
        <van-cell
          v-show="ccxsData.length != 0"
          :title="bqccxszjz"
          size="large"
          style="text-align: right"
        ></van-cell>
        <info-title title-content="上传材料" vertical-line="true" />

        <template v-if="this.fromSQBG === 'true'">
          <info-title
            title-content="变更担保申请书"
            required-description="必填"
          />
          <van-uploader
            name="11"
            :after-read="fileUpload"
            :before-read="beforeRead"
            class="uploader"
            v-model="bgdbsqs"
            :max-count="5"
            :before-delete="deleteCl"
          ></van-uploader>
        </template>

        <info-title
          :title-content="
            (this.fromSQBG === 'true' ? '变更后保全' : '保全') + '申请书'
          "
          required-description="必填"
        />
        <van-uploader
          name="1"
          :after-read="fileUpload"
          :before-read="beforeRead"
          class="uploader"
          v-model="sqs"
          :max-count="5"
          :before-delete="deleteCl"
        ></van-uploader>
        <!-- <UploadFile ref="sqs"
                            :is-b-q="false"
                            :id="dbid"
                            upload-url="ssbq/api/ssdb/fileupload"
                            del-url="ssbq/api/ssdb/delsccl"
                            cllx="1"
                            :list="sqs"
                            key-name="cDbclid"></UploadFile> -->

        <!--立案受理通知书 在诉前保全为非必填，在诉讼保全为必填-->
        <info-title
          title-content="立案受理通知书"
          :required-description="basicData.cBqlb == 1 ? '' : '必填'"
        />
        <van-uploader
          name="6"
          :before-read="beforeRead"
          :after-read="fileUpload"
          class="uploader"
          v-model="lasltzs"
          :max-count="5"
          :before-delete="deleteCl"
        ></van-uploader>
        <info-title
          :title-content="(this.fromSQBG === 'true' ? '变更后' : '') + '起诉状'"
          :required-description="basicData.cBqlb == 2 ? '必填' : ''"
        />
        <van-uploader
          name="2"
          :after-read="fileUpload"
          class="uploader"
          :before-read="beforeRead"
          v-model="qsz"
          :before-delete="deleteCl"
          :max-count="5"
        ></van-uploader>
        <!-- <UploadFile ref="qsz"
                            :is-b-q="false"
                            :id="dbid"
                            upload-url="ssbq/api/ssdb/fileupload"
                            del-url="ssbq/api/ssdb/delsccl"
                            cllx="2"
                            :list="qsz"
                            key-name="cDbclid"></UploadFile> -->
        <info-title title-content="身份证明类" required-description="必填" />
        <div v-for="(item, index) in sfzml" :key="item.ryid + index">
          <van-field
            class="fd-com-person-name"
            disabled
            :label="item.rymc"
          ></van-field>
          <van-uploader
            :name="item.ryid"
            :after-read="fileUpload"
            :before-read="beforeRead"
            class="uploader"
            v-model="item.clList"
            :before-delete="deleteCl"
            :max-count="5"
          ></van-uploader>
          <!-- <UploadFile :ref="'sfzml'+index"
                                :is-b-q="false"
                                :id="dbid"
                                upload-url="ssbq/api/ssdb/fileupload"
                                del-url="ssbq/api/ssdb/delsccl"
                                cllx="3"
                                :list="item.clList"
                                key-name="cDbclid"></UploadFile> -->
        </div>
        <info-title title-content="证据类" required-description="必填" />
        <van-uploader
          name="5"
          :after-read="fileUpload"
          :before-read="beforeRead"
          class="uploader"
          v-model="zjl"
          :before-delete="deleteCl"
          :max-count="20"
        ></van-uploader>
        <!-- <UploadFile ref="zjl"
                            :is-b-q="false"
                            :id="dbid"
                            upload-url="ssbq/api/ssdb/fileupload"
                            del-url="ssbq/api/ssdb/delsccl"
                            cllx="5"
                            :list="zjl"
                            key-name="cDbclid"></UploadFile> -->
        <info-title title-content="其他" />
        <van-uploader
          name="255"
          :before-read="beforeRead"
          :after-read="fileUpload"
          class="uploader"
          v-model="qt"
          :before-delete="deleteCl"
          :max-count="20"
        ></van-uploader>
        <!-- <UploadFile ref="qt"
                            :is-b-q="false"
                            :id="dbid"
                            upload-url="ssbq/api/ssdb/fileupload"
                            del-url="ssbq/api/ssdb/delsccl"
                            cllx="255"
                            :list="qt"
                            key-name="cDbclid"></UploadFile> -->
        <div class="uploading-wrap" v-show="isUpload">
          <div class="upload-text">
            <van-loading class="icon-upload" type="spinner" />
            <span>上传中...</span>
          </div>
        </div>
        <!-- <info-title
          title-content="担保机构"
          required-description="必填"
          vertical-line="true"
        >
        </info-title>
        <van-swipe-cell v-for="(item, index) in dbjgData" :key="item.id">
          <van-cell
            :title="item.name"
            :value="item.value"
            @click="goToDbjg(item.id, item.value)"
            is-link
          />
        </van-swipe-cell> -->
      </van-cell-group>
    </div>
    <div class="fd-com-btn-container">
      <van-button
        v-if="!(this.formData.cDbzt === '5' && this.fromSQBG === 'true')"
        type="info"
        round
        plain
        :disabled="!saveBtnClickable"
        @click="temporaryStorageDb"
      >
        暂存
      </van-button>
      <van-button
        type="info"
        round
        :disabled="!saveBtnClickable"
        @click="onInfoSubmit()"
      >
        提交
      </van-button>
    </div>
  </div>
</template>

<script>
import UploadFile from "../../components/common/uploadFile";
import MyTitle from "../../components/common/myTitle";
import MyButton from "../../components/common/myButton";
import InfoTitle from "../../components/common/InfoTitle";
import { getTreeDataById } from "../../utils/common";
import { Notify, Dialog, Toast, Loading } from "vant";
import {
  typeRylx,
  typeDlrlx,
  typeCclx,
  typeBqlb,
  typeTjrlx,
  typeAjlx,
  typeBqlx,
  typeFsccFsqj,
  accAdd,
  typeSddy,
} from "../../filters/index";
import validate from "@/utils/validator/validator";
import {
  ahRule,
  ayRule,
  bgdbsqsclRule,
  bgsqsclRule,
  sqsclRule,
  bgqszclRule,
  qszclRule,
  SfzmlclRule,
  zjlclRule,
  sqrxxRule, // 申请人信息
  bsqrxxRule, // 被申请人信息
  ygdlrRule, // 原告代理人信息
  ccxsxxRule, // 财产线索信息
  lasltzsRule, // 立案受理通知书
  sizeRule,
} from "@/utils/validator/rules";
import {
  getDbjbxx,
  getSqrs,
  getBsqrs,
  getYgdlrs,
  getCcxss,
  getSccls,
  getDbbgBbjbxx,
  deleteSqr,
  delXcxSqr,
  deleteBsqr,
  delXcxBsqr,
  deleteDlr,
  delXcxDlr,
  deleteCcxs,
  delXcxCcxs,
  fileUpload,
  fileXcxUpload,
  delSccl,
  delXcxSccl,
  commitDb,
  commitBgdb,
  getBgdbzt,
} from "../../api/guarantee";

export default {
  data() {
    return {
      dbid: "",
      isSubmit: "",
      showStatus: false,
      basicData: {
        cFymc: "", // 申请法院
        cDbzt: "", //担保状态
        cBxgs: "",
        cBxgsmc: "", // 担保机构
        cBqlx: "", // 保全类型
        cBqlxText: "", // 保全类型
        cBqlb: "", // 保全类别
        cBqlbText: "", // 保全类别
        cFsqj: "", // 非诉期间
        cFsqjText: "", // 非诉期间
        nSqbqje: "", // 申请保全金额
        nDbfy: "", // 担保费用
        cFl: "", // 担保费率
        cTjr: "", // 提交人
        cTjrlx: "", // 提交人身份
        cTjrlxText: "", // 提交人身份
        cClerkNo: "", //咨询员编号
        dtCreatetime: "",
        dtTjsj: "", //提交日期
        cAyName: "",
        cAyxzxwName: "",
        cXzaymc: "",
      },
      sqrData: [],
      dlrData: [],
      bsqrData: [],
      ccxsData: [],
      cczjz: 0, // 财产总价值
      formData: {
        cAh: "", // 案号
        cAy: "", // 案由
        nAjlx: "", // 案件类型
        nAjlxText: "",
        cAyName: "",
      },
      bgdbsqs: [], //变更担保申请书 必填
      sqs: [], // 申请书材料 必填
      lasltzs: [], // 立案受理通知书材料
      qsz: [], // 起诉状材料 必填
      sfzml: [], // 身份证明类材料 必填,分别校验每个申请人
      zjl: [], // 证据类材料 必填
      qt: [], // 其他,
      fileList: [
        {
          url: "https://img.yzcdn.cn/vant/cat.jpeg",
          name: "123",
          id: "10086",
        },
      ],
      saveBtnClickable: true, // 保存按钮是否可以点击
      scroll: 0, //保留上次离开的高度
      bqccxszjz: "",
      isUpload: false,
      AyTree2List: {},
      //cAyxzxwName:''

      fromSQBG: sessionStorage.getItem("fromSQBG"),
    };
  },
  computed: {
    dbjgData() {
      return [
        {
          name: "担保机构",
          id: this.basicData.cBxgs,
          value: this.basicData.cBxgsmc,
        },
      ];
    },
    // cczjzText: function () {
    //     return "总价值: " + this.cczjz.toFixed(2) + " 元";
    // }
  },
  components: {
    MyTitle,
    InfoTitle,
    UploadFile,
    MyButton,
  },
  created() {
    // 初始化不需要更新数据
    this.initNoUpdateData();
    // 获取上一个页面传递的担保id
    let dbid = JSON.parse(sessionStorage.getItem("currentDbid"));
    if (!dbid || dbid == "undefined") {
      this.$notify("获取担保id发生错误");
      return;
    }
    this.dbid = dbid;
    this.initAyList();
  },
  activated() {
    this.initAllData();

    /*//基本信息
            this.initBasicData();
            this.initSqrData();
            this.initBSQRData();
            this.initDlrData();
            this.initCCXSData();
            this.initClxxData();*/
  },
  methods: {
    /**
     * 初始化不需要更新的数据
     * @returns {void}
     * */
    initNoUpdateData() {
      // 申请人数据列表
      this.sqrDataList = [];
    },
    //案号案由提示
    toast(value) {
      Toast(value);
    },
    initAyList: function () {
      this.$axios.get("ssbq/api/bqsqs/new/ay", {}).then((res) => {
        var dataList = res.data["2021"]["62"]["0"].children;
        var list = {};
        getTreeDataById(dataList, list);
        //this.ayList=list
        this.AyTree2List = list;

        // });
      });
    },
    goToSQR: function (sqrId) {
      if (sqrId && sqrId != "undefined") {
        sessionStorage.setItem("sqrId", sqrId);
      } else {
        sessionStorage.setItem("sqrId", "");
      }
      this.$router.push({
        path: "/addSQR",
        query: { cDbzt: this.formData.cDbzt },
      });
    },
    goToAddYGDLR: function (ygdlrId) {
      if (ygdlrId && ygdlrId != "undefined") {
        sessionStorage.setItem("ygdlrId", ygdlrId);
        sessionStorage.setItem("ygdlrIds", ygdlrId);
      } else {
        sessionStorage.setItem("ygdlrId", "");
      }
      this.$router.push({
        path: "/addYGDLR",
        query: { cDbzt: this.formData.cDbzt },
      });
    },
    goToAddCCXS: function (ccxsId) {
      if (ccxsId && ccxsId != "undefined") {
        sessionStorage.setItem("ccxsId", ccxsId);
      } else {
        sessionStorage.setItem("ccxsId", "");
      }
      this.$router.push({
        path: "/addCCXS",
        query: { cDbzt: this.formData.cDbzt },
      });
    },
    goToAddBSQR: function (bsqrId) {
      if (bsqrId && bsqrId != "undefined") {
        sessionStorage.setItem("bsqrId", bsqrId);
      } else {
        sessionStorage.setItem("bsqrId", "");
      }
      this.$router.push({
        path: "/addBSQR",
        query: { cDbzt: this.formData.cDbzt },
      });
    },
    goToDbjg: function (BxgsId, Bxgsmc) {
      if (BxgsId && BxgsId != "undefined") {
        sessionStorage.setItem("BxgsId", BxgsId);
        sessionStorage.setItem("Bxgsmc", Bxgsmc);
      } else {
        sessionStorage.setItem("BxgsId", "");
        sessionStorage.setItem("Bxgsmc", "");
      }
      this.$nextTick(function () {
        this.$router.push({
          path: "/addDBJG",
        });
      });
    },
    initNew: function () {
      if (this.fromSQBG !== "true" && this.formData.cDbzt === "6") {
        this.changeDbstate();
      }
      this.initAllData();
    },
    initAllData: function () {
      if (this.fromSQBG === "true") {
        console.log("--initAllData 变更 是");
        getDbbgBbjbxx(this.dbid)
          .then((res) => {
            console.log("--getDbbgBbjbxx 111", res);
            let { dbJbxx, dbSqrs, dbDsrs, dbDlrs, dbPropertys, scclVo } =
              res.data;
            console.log("--111", dbJbxx);
            console.log("--222", dbSqrs);
            console.log("--333", dbDsrs);
            console.log("--444", dbDlrs);
            console.log("--555", dbPropertys);
            console.log("--666", scclVo);

            this.initBasicData({ data: dbJbxx });
            this.initSqrData({ data: dbSqrs });
            this.initBSQRData({ data: dbDsrs });
            this.initDlrData({ data: dbDlrs });
            this.initCCXSData({ data: dbPropertys });
            this.initClxxData({ data: scclVo });
          })
          .catch(function (error) {
            console.log("--catch 123");
            console.log(error);
          });
      } else {
        console.log("--initAllData 变更 非");
        this.initGetBasicData();
        this.initGetSqrData();
        this.initGetBSQRData();
        this.initGetDlrData();
        this.initGetCCXSData();
        this.initGetClxxData();
      }
    },
    initGetBasicData: function () {
      getDbjbxx({ dbid: this.dbid })
        .then((res) => {
          this.initBasicData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initGetSqrData: function () {
      getSqrs({ dbid: this.dbid })
        .then((res) => {
          this.initSqrData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initGetBSQRData: function () {
      getBsqrs({ dbid: this.dbid })
        .then((res) => {
          this.initBSQRData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initGetDlrData: function () {
      getYgdlrs({ dbid: this.dbid })
        .then((res) => {
          this.initDlrData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initGetCCXSData: function () {
      getCcxss({ dbid: this.dbid })
        .then((res) => {
          this.initCCXSData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initGetClxxData: function () {
      getSccls({ dbid: this.dbid })
        .then((res) => {
          this.initClxxData(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //修改重新申请的状态
    changeDbstate: function () {
      getBgdbzt({ dbid: this.dbid })
        .then((res) => {})
        .catch(function (error) {
          console.log(error);
        });
    },

    initBasicData: function (res) {
      const dealRes = (res) => {
        console.log("--init 000");
        let data = res.data;
        let { cAhNf, nAjlx } = data;
        var key = Number(cAhNf) >= 2021 ? 2021 : 2020;
        console.log("--init basic", cAhNf, nAjlx, key);
        if (key === 2020) {
          this.ayLabel_1 = Number(nAjlx) === 6 ? "案由(主体类型)" : "案由";
          this.ayLabel_2 = "案由(行为种类)";
        } else {
          this.ayLabel_1 = Number(nAjlx) === 6 ? "行政主体类型" : "案由";
          this.ayLabel_2 = "行政案由";
        }

        this.basicData.cFymc = data.cFymc;
        this.basicData.cBxgs = data.cBxgs;
        this.basicData.cBxgsmc = data.cBxgsmc;
        this.basicData.cBqlx = data.cBqlx;
        this.basicData.cBqlxText = typeBqlx(data.cBqlx);
        this.basicData.cBqlb = data.cBqlb;
        this.basicData.cBqlbText = typeBqlb(data.cBqlb);
        this.basicData.nSqbqje = data.nSqbqje;
        this.basicData.nDbfy = data.nDbfy;
        this.basicData.cFl = data.cFl;
        this.basicData.cTjr = data.cTjr;
        this.basicData.cTjrlx = data.cTjrlx;
        this.basicData.cTjrlxText = typeTjrlx(data.cTjrlx);
        this.basicData.cClerkNo = data.cClerkNo || "--";
        this.formData.cAhNf = data.cAhNf;
        this.formData.cAh = `（${data.cAhNf}）${data.cAhFydz}${data.cAhAjlxdz}${data.cAhAjxh}号`;
        this.formData.cAy = data.cAy;
        this.formData.cXzaymc = data.cXzaymc;
        this.formData.nAjlx = data.nAjlx;
        this.formData.cDbzt = data.cDbzt;
        this.formData.nAjlxText = typeAjlx(data.nAjlx);
        this.basicData.dtCreatetime = data.dtCreatetime;
        this.basicData.dtTjsj = data.dtTjsj || "--";
        this.basicData.cFsqj = data.cFsqj;
        this.basicData.cFsqjText = typeFsccFsqj(data.cFsqj);
        //初始化案由

        //var _this=this;
        if (nAjlx === 6) {
          //初始化案由
          let cAyName = data.cAy.split(";");
          this.formData.cAyName = cAyName.splice(0, 1).join(";");
          //this.formData.cAyxzxwName = cAyName.join(';')

          if (key === 2021) {
            console.log("--key 111");
            this.$axios.get("ssbq/api/bqsqs/new/ay", {}).then((res) => {
              console.log("--initAyList");
              var dataList = res.data["2021"]["62"]["0"].children;
              var list = {};
              getTreeDataById(dataList, list);

              var ids = data.cAyxzxw;
              ids =
                ids.slice(ids.length - 1) === ","
                  ? ids.slice(0, ids.length - 1).split(",")
                  : ids.slice(0, ids.length).split(",");
              var texts = "";
              ids.map((item) => {
                texts += list[item] + ";";
              });
              this.basicData.cAyxzxwName = texts;
            });
          } else {
            this.basicData.cAyxzxwName = cAyName.join(";");
          }
        } else {
          this.formData.cAyName = data.cAy;
        }
      };

      dealRes(res);
    },
    initSqrData: function (res) {
      // 申请人数据列表赋值
      this.sqrDataList = res.data;
      this.sqrData = [];

      /* this.$axios.get('ssbq/api/ssdb/sqrs?dbid=' + this.dbid)
                    .then(res => {
                        dealRes(res);
                    }).catch(function (error) {
                    console.log(error)
                });*/

      const dealRes = (res) => {
        let data = res.data;
        data.forEach((item) => {
          let sqr = {};
          sqr.cSqrlx = typeRylx(item.cSqrlx);
          if (item.cSqrlx == 1) {
            // sqr.cSqrxm = item.cSqrxm;
            sqr.cSqrxm =
              item.cSqrxm.length > 15
                ? item.cSqrxm.substring(0, 15) + "..."
                : item.cSqrxm;
          } else {
            // sqr.cSqrxm = item.cQymc;
            sqr.cSqrxm =
              item.cQymc.length > 15
                ? item.cQymc.substring(0, 15) + "..."
                : item.cQymc;
          }
          sqr.cId = item.cId;
          this.sqrData.push(sqr);
        });
        //申请人去重
        let obj = {};
        this.sqrData = this.sqrData.reduce(function (item, next) {
          obj[next.cId] ? "" : (obj[next.cId] = true && item.push(next));
          return item;
        }, []);
      };
      dealRes(res);
    },
    initDlrData: function (res) {
      this.dlrData = [];

      /*this.$axios.get('ssbq/api/ssdb/ygdlrs?dbid=' + this.dbid)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/

      const dealRes = (res) => {
        let data = res.data;
        data.forEach((item) => {
          let dlr = {};
          dlr.cId = item.cDbDlrid;
          dlr.cDlrlx = typeDlrlx(item.cDlrlx);
          dlr.cDlrxm = item.cDlrxm;
          dlr.dlrmc =
            item.cDlrxm.length > 20
              ? item.cDlrxm.substring(0, 20) + "..."
              : item.cDlrxm;
          this.dlrData.push(dlr);
        });
        //代理人去重
        let obj = {};
        this.dlrData = this.dlrData.reduce(function (item, next) {
          obj[next.cId] ? "" : (obj[next.cId] = true && item.push(next));
          return item;
        }, []);
      };
      dealRes(res);
    },
    initCCXSData: function (res) {
      this.ccxsData = [];

      /*this.$axios.get('ssbq/api/ssdb/ccxss?dbid=' + this.dbid)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/

      const dealRes = (res) => {
        let data = res.data;
        let ccjz = 0;
        // this.ccxsData = data;
        // 遍历财产数据列表,构造显示数据
        data.forEach((item) => {
          let temp = {
            cDbppid: item.cDbppid,
            cSqdbccyyz: item.cSqdbccyyz,
            cSqdbccyyzText: "",
            cCclx: item.cCclx,
            cCclxText: typeCclx(item.cCclx),
            description: "",
            cSqbqccje: item.cSqbqccje,
            cSqbqccjeText: item.cSqbqccje + " 元",
          };
          // 获得财产所有人姓名
          this.bsqrData.forEach((bsqr) => {
            if (bsqr.cDbDsrid == temp.cSqdbccyyz) {
              temp.cSqdbccyyzText = bsqr.cDsrxm;
              temp.ccxsmc =
                typeCclx(item.cCclx) +
                ":  " +
                (bsqr.cDsrxm.length > 15
                  ? bsqr.cDsrxm.substring(0, 15) + "..."
                  : bsqr.cDsrxm);
            }
          });
          ccjz += Number(temp.cSqbqccje) * 100;
          this.cczjz = (ccjz / 100).toFixed(2);
          this.bqccxszjz = "财产总价值：" + this.cczjz + "元";
          temp.description = temp.cSqdbccyyzText + " " + temp.cCclxText;
          this.ccxsData.push(temp);
        });
        //财产线索去重
        let obj = {};
        this.ccxsData = this.ccxsData.reduce(function (item, next) {
          obj[next.cDbppid]
            ? ""
            : (obj[next.cDbppid] = true && item.push(next));
          return item;
        }, []);
      };
      dealRes(res);
    },
    initBSQRData: function (res) {
      this.bsqrData = [];

      /*this.$axios.get('ssbq/api/ssdb/bsqrs?dbid=' + this.dbid)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/

      const dealRes = (res) => {
        window.sessionStorage.setItem("dbbsqrList", JSON.stringify(res.data));
        let data = res.data;
        data.forEach((item) => {
          let bsqr = {
            cDbDsrid: item.cDbDsrid,
            cDsrlx: item.cDsrlx,
            cDsrlxText: typeRylx(item.cDsrlx),
          };
          if (item.cDsrlx == 1) {
            // 当事人类型为自然人
            // bsqr.cDsrxm = item.cDsrxm;
            bsqr.cDsrxm =
              item.cDsrxm.length > 15
                ? item.cDsrxm.substring(0, 15) + "..."
                : item.cDsrxm;
          } else {
            // bsqr.cDsrxm = item.cQymc;
            bsqr.cDsrxm =
              item.cQymc.length > 15
                ? item.cQymc.substring(0, 15) + "..."
                : item.cQymc;
          }
          this.bsqrData.push(bsqr);
        });

        //被申请人去重
        let obj = {};
        this.bsqrData = this.bsqrData.reduce(function (item, next) {
          obj[next.cDbDsrid]
            ? ""
            : (obj[next.cDbDsrid] = true && item.push(next));
          return item;
        }, []);
      };

      dealRes(res);
    },
    initClxxData: function (res) {
      this.bgdbsqs = [];
      this.sqs = [];
      this.lasltzs = [];
      this.qsz = [];
      this.sfzml = [];
      this.zjl = [];
      this.qt = [];

      /*this.$axios.get('ssbq/api/ssdb/sccls?dbid=' + this.dbid)
                    .then(res => {

                    }).catch(function (error) {
                    console.log(error)
                });*/

      const dealRes = (res) => {
        let data = res.data;
        this.bgdbsqs = data.bgdbsqs; //变更担保申请书
        this.sqs = data.sqs; // 申请书材料
        this.lasltzs = data.lasltzs; // 立案受理通知书材料
        this.qsz = data.qsz; // 起诉状材料,
        this.sfzml = data.sfzml; // 身份证明类材料
        // 当前后台返回人员名称格式为 姓名-类型
        // 当前要展示格式为 类型-姓名 需要通过 - 分割返回字段值, 调换展示顺序和处理过长的姓名
        /*this.sfzml.forEach(ele => {
                        let rymcAndType = ele.rymc;
                        if (rymcAndType) {
                            let arr = rymcAndType.split('-');
                            let name = arr[0];
                            let type = arr[1];
                            name = name.length > 15 ? name.substr(0, 15) + '...' : name;
                            ele.rymc = type + '-' + name;
                        }
                    });*/
        this.zjl = data.zjl; // 证据类材料
        this.qt = data.qt; // 其他
      };

      dealRes(res);
    },
    // 上传验证
    beforeRead(file) {
      if (file.size == 0) {
        Notify("上传文件必须大于0kb!");
      }
      let fileType = "image/jpeg||image/jpg||image/bmp||image/gif||image/png";
      let imgFormat = "jpg、png、jpeg、bmp、gif";
      if (fileType.indexOf(file.type) === -1) {
        Notify({
          message: `仅支持格式为${imgFormat}的图片!`,
          type: "danger",
          duration: 5 * 1000,
        });
        return false;
      } else if (file.size > 20 * 1024 * 1024) {
        Notify("上传文件大小不能超过 20MB!");
        return false;
      }
      return true;
    },
    async fileUpload(file, name) {
      this.isUpload = true;
      this.saveBtnClickable = false;
      // cllx 1申请书, 6立案受理通知书, 2起诉状, 3身份证明类, 5证据类, 255其他
      let currentDbid = JSON.parse(sessionStorage.getItem("currentDbid"));
      let i = 0;
      const fd = new FormData();
      let clid = await this.myId(i);
      // name.name不为1, 2, 5, 6, 255时,name.name代表所属申请人id,cllx为3身份证明类
      let cllx = name.name;
      if (
        cllx != "1" &&
        cllx != "2" &&
        cllx != "5" &&
        cllx != "6" &&
        cllx != "11" &&
        cllx != "255"
      ) {
        fd.append("id", cllx);
        cllx = 3;
      }
      let f = file.file;
      fd.append("files", f);
      fd.append("dbid", currentDbid);
      fd.append("cllx", cllx);
      fd.append("clid", clid);

      var fnGet = this.fromSQBG === "true" ? fileXcxUpload : fileUpload;
      fnGet(fd)
        .then((res) => {
          this.isUpload = false;
          if (res.code == 200) {
            this.$notify({ type: "success", message: "材料上传成功" });
          } else {
            this.$notify(res.message);
          }
          // this.initClxxData();
          this.initNew();
          this.saveBtnClickable = true;
        })
        .catch(function (error) {
          console.log(error);
          this.saveBtnClickable = true;
        });

      /*this.$axios.post('ssbq/api/ssdb/fileupload', fd)
                    .then(res => {
                    }).catch(function (error) {
                    this.saveBtnClickable = true;
                    console.log(error)
                });*/
    },
    deleteCl: function (name) {
      if (this.isUpload != true) {
        var fnGet = this.fromSQBG === "true" ? delXcxSccl : delSccl;
        fnGet({ id: name.cDbclid, dbid: this.dbid })
          .then((res) => {
            // this.initClxxData();
            this.initNew();
            this.$notify({ type: "success", message: "材料删除成功" });
          })
          .catch(function (error) {
            console.log(error);
          });

        /*this.$axios.delete('ssbq/api/ssdb/delsccl?id=' + name.cDbclid +"&dbid=" + this.dbid)
                        .then(() => {
                        }).catch(function (error) {
                        console.log(error)
                    });*/
      } else {
        this.$notify("上传过程中不能删除！");
      }
    },
    deleteSQR: function (cId, index) {
      Dialog.confirm({
        title: "提示",
        message:
          "删除申请人后，对应的原告代理人或身份证明材料可能会一并删除，确认删除吗？",
        confirmButtonColor: "#ffffff",
        cancelButtonColor: "#ffffff",
      })
        .then(() => {
          var fnDel = this.fromSQBG === "true" ? delXcxSqr : deleteSqr;
          fnDel({ sqrid: cId, dbid: this.dbid })
            .then((res) => {
              this.$notify({ type: "success", message: "删除成功" });
              /*this.initSqrData();
                         this.initDlrData();
                         this.initClxxData();*/
              this.initNew();
              /* this.initGetSqrData();
                         this.initGetDlrData();
                         this.initGetClxxData();*/
            })
            .catch(function (error) {
              console.log(error);
            });

          /*this.$axios.delete('ssbq/api/xcx/deletesqr?sqrid=' + cId +"&dbid=" + this.dbid)
                            .then(res => {
                                this.$notify({'type': 'success', 'message': '删除成功'});
                                /!*this.initSqrData();
                                this.initDlrData();
                                this.initClxxData();*!/
                                this.initGetSqrData();
                                this.initGetDlrData();
                                this.initGetClxxData();

                            }).catch(function (error) {
                            console.log(error)
                        });*/
        })
        .catch(() => {});
      return;
    },
    deleteBSQR: function (cDbDsrid, index) {
      Dialog.confirm({
        title: "提示",
        message: "删除被申请人后，对应的财产线索会一并删除，确认删除吗？",
        confirmButtonColor: "#ffffff",
        cancelButtonColor: "#ffffff",
      })
        .then(() => {
          var fnDel = this.fromSQBG === "true" ? delXcxBsqr : deleteBsqr;
          fnDel({ bsqrid: cDbDsrid, dbid: this.dbid })
            .then((res) => {
              this.$notify({ type: "success", message: "删除成功" });
              /*this.initBSQRData();
                             this.initCCXSData();*/
              this.initNew();
              /*this.initGetBSQRData();
                             this.initGetCCXSData();*/
            })
            .catch(function (error) {
              console.log(error);
            });
          /*this.$axios.delete('ssbq/api/xcx/deletebsqr?bsqrid=' + cDbDsrid +"&dbid=" + this.dbid)
                            .then(res => {

                            }).catch(function (error) {
                            console.log(error)
                        });*/
        })
        .catch(() => {});
      return;
    },
    deleteYGDLR: function (cId, index) {
      Dialog.confirm({
        title: "提示",
        message:
          "删除原告代理人后，对应的原告代理人身份证明材料会一并删除，确认删除吗？",
        confirmButtonColor: "#ffffff",
        cancelButtonColor: "#ffffff",
      })
        .then(() => {
          var fnGet = this.fromSQBG === "true" ? delXcxDlr : deleteDlr;
          fnGet({ dlrid: cId, dbid: this.dbid }, this.postData)
            .then((res) => {
              this.dlrData.splice(index, 1);
              // this.initClxxData();
              this.initNew();
            })
            .catch(function (error) {
              console.log(error);
            });
          /*this.$axios.delete('ssbq/api/xcx/deletedlr?dlrid=' + cId +"&dbid=" + this.dbid)
                            .then(res => {
                            }).catch(function (error) {
                            console.log(error)
                        });*/
        })
        .catch(() => {});
      return;
    },
    deleteCCXS: function (cDbppid, index) {
      this.cczjz = 0;
      this.ccxsData.forEach((temp) => {
        this.cczjz += temp.cSqbqccje * 100;
      });
      this.bqccxszjz = "总价值：" + (this.cczjz / 100).toFixed(2) + "元";

      var fnGet = this.fromSQBG === "true" ? delXcxCcxs : deleteCcxs;
      fnGet({ dbid: this.dbid, ccxsid: cDbppid })
        .then((res) => {
          this.$notify({ type: "success", message: "删除成功" });
          this.ccxsData.splice(index, 1);
          /*this.initCCXSData().then(()=>{
                        window.location.reload();
                    })*/
          this.initNew();
        })
        .catch(function (error) {
          console.log(error);
        });

      /*this.$axios.delete('ssbq/api/xcx/deleteccxs?ccxsid=' + cDbppid +"&dbid=" + this.dbid)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/
    },

    /**
     * 验证申请人
     * @returns {String} 校验警告信息
     * */
    verifySQR() {
      let result = "";
      // 遍历申请人列表，如果申请人类型为1 自然人 并且证件类型为1 身份证，如果证件有效期为空，则提示警告
      this.sqrDataList.some((sqrItem) => {
        // 如果申请人类型为1 自然人 并且证件类型为1 身份证，如果证件有效期为空
        const _zjyxqFlag =
          sqrItem.cSqrlx === "1" &&
          sqrItem.cZjlx === "1" &&
          (!sqrItem.dtZjyxqKsrq || !sqrItem.dtZjyxqJsrq);
        // 证件有效期和单位性质校验
        if (_zjyxqFlag) {
          result = `请完善申请人${sqrItem.cSqrxm}的信息`;
          return true;
        }
        // 单位性质校验，不能为空
        const _dwxzFlag =
          (sqrItem.cSqrlx === "2" || sqrItem.cSqrlx === "3") && !sqrItem.cDwxz;
        if (_dwxzFlag) {
          result = `请完善申请人${sqrItem.cQymc}的信息`;
          return true;
        }
        return false;
      });
      return result;
    },
    onInfoSubmit: function () {
      // 校验表单信息是否完整
      const validated = this.validateFormData();
      validated.then(() => {
        // 申请人校验
        const _sqrVerifyResult = this.verifySQR();
        if (_sqrVerifyResult) {
          this.$notify(_sqrVerifyResult);
          return;
        }
        // 校验上传材料信息是否完整
        const validatedClxx = this.validateClxx();
        // return false;
        validatedClxx.then(() => {
          // 信息校验通过, 提交表单
          // 案件信息为上个页面传递到服务器的, 此处再传递一次, 通知服务器更改提交状态
          this.submitInfo().then(() => {
            this.$router.push("/home/myGuarantee");
            this.isSubmit = 1;
          });
        });
      });
    },
    submitInfo: function () {
      this.saveBtnClickable = false;
      let currentDbid = JSON.parse(sessionStorage.getItem("currentDbid"));
      let postData = {
        cAh: this.formData.cAh,
        cAy: this.formData.cAy,
      };

      var fnGet = this.fromSQBG === "true" ? commitBgdb : commitDb;
      return fnGet(currentDbid)
        .then((res) => {
          if (res.code == 200) {
            this.$notify({
              type: "success",
              message: "提交成功，请刷新担保列表",
            });
            this.$router.push("/");
          } else {
            this.$notify(res.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      /*return this.$axios.post('commonapi/api/policy/guarantee/apply?jbxxid=' + currentDbid)
                    .then(res => {
                    }).catch(function (error) {
                        console.log(error)
                    });*/
    },
    validateFormData: function () {
      let descriptor = {
        // cAh: ahRule,
        // cAy: ayRule,
        sqrData: sqrxxRule,
        // dlrData: ygdlrRule,
        bsqrData: bsqrxxRule,
        ccxsData: ccxsxxRule,
      };
      let data = Object.assign({}, this.formData);
      data.sqrData = this.sqrData;
      // data.dlrData = this.dlrData;
      data.bsqrData = this.bsqrData;
      data.ccxsData = this.ccxsData;
      const validated = validate(descriptor, data);
      return validated;
    },
    validateClxx: function () {
      /*let descriptor = {
                    sqs: sqsclRule, // 申请书材料 必填
                    //qsz: qszclRule, // 起诉状材料 必填
                    sfzml: new SfzmlclRule(true), // 身份证明类材料 必填,分别校验每个申请人
                    zjl: zjlclRule // 证据类材料 必填
                };*/
      let descriptor = {};
      if (this.fromSQBG === "true") {
        descriptor.bgdbsqs = bgdbsqsclRule;
        descriptor.sqs = bgsqsclRule;
      } else {
        descriptor.sqs = sqsclRule;
      }

      descriptor.sfzml = new SfzmlclRule(true);
      descriptor.zjl = zjlclRule;

      if (this.basicData.cBqlb == 2) {
        // 诉讼保全时立案受理通知书必填
        descriptor.qsz = this.fromSQBG === "true" ? bgqszclRule : qszclRule;
        descriptor.lasltzs = lasltzsRule;
      }

      var checkData = {};
      if (this.fromSQBG === "true") {
        checkData.bgdbsqs = this.bgdbsqs;
      }
      checkData = Object.assign(
        {
          sqs: this.sqs, // 申请书材料 必填
          qsz: this.qsz, // 起诉状材料 必填
          sfzml: this.sfzml, // 身份证明类材料 必填,分别校验每个申请人
          zjl: this.zjl, // 证据类材料 必填
          lasltzs: this.lasltzs, // 立案受理通知书,诉讼保全时必填
        },
        checkData
      );
      const validated = validate(descriptor, checkData);
      return validated;
    },
    temporaryStorageDb() {
      console.log("--暂存 123", this.formData.cDbzt);
      if (this.formData.cDbzt === "1") {
        this.$notify({ type: "success", message: "暂存成功" });
      } else if (this.formData.cDbzt === "6") {
        this.$notify("您未修改任何信息，无需暂存");
      } else {
        this.$notify("此担保已经提交过了，无需再次暂存");
      }

      this.saveBtnClickable = true;
    },
    myId(i) {
      return new Promise((resolve) => {
        i++;
        if (i > 3) {
          this.$notify("系统异常");
        } else {
          this.getId()
            .then((res) => {
              resolve(res.data);
            })
            .catch(() => {
              this.myId(i);
            });
        }
      });
    },
    getId() {
      return new Promise((resolve) => {
        this.$axios
          .get("ssbq/api/id")
          .then((res) => {
            if (res.code == 200) {
              resolve(res);
            } else {
              this.$notify(res.message);
            }
          })
          .catch(() => {
            this.$notify("系统异常");
          });
      });
    },
  },
  //在页面离开时记录滚动位置
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "addSQR" ||
      to.name == "addBSQR" ||
      to.name == "addYGDLR" ||
      to.name == "addCCXS" ||
      to.name == "addDBJG"
    ) {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      // this.$destroy()
      next((vm) => {
        vm.isActived = false;
      });
    }
    //获取高度值
    const scrollHeight = this.$refs.element;
    this.scroll = scrollHeight.scrollTop;
    next();
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "myGuarantee" || from.name == "createGuarantee") {
        window.location.reload();
      }
      const scrollHeight = vm.$refs.element;
      // 记录滚动高度
      scrollHeight.scrollTop = vm.scroll;
    });
  },
};
</script>

<style lang="less" scoped>
.create-guarantee-info {
  width: 100%;
  height: 100%;
}

/deep/.upload-icon {
  margin-top: 34px;
}
.fd-upload-wrap {
  position: relative;
}

.uploading-wrap {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  margin-left: -60px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-text {
  .icon-upload {
    text-align: center;
  }
  > span {
    font-size: 18px;
    color: #fff;
  }
}

.col-key {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
}

.col-value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
}

.guarantee-basic-info-inner {
  margin: 0 20px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 12px 0;
  box-shadow: 0px 0px 1px #f5f5f5;
}

.guarantee-basic-info {
  background-color: #edf1f8;
}

/deep/.van-row {
  line-height: 28px;
}

.col-value {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-button {
  padding: 6px 8px;
  display: inline-block;
  font-size: 14px !important;
  margin-left: 6px;
}
/deep/ .van-loading__text {
  font-size: 20px;
  color: #fff !important;
}
.fd-type {
  color: #333333;
}

/deep/.van-icon-delete:before {
  content: "\F031";
}

/*/deep/.van-uploader__preview-delete {*/
/*    position: absolute;*/
/*    height: 10%;*/
/*    top: -8px;*/
/*    right: -8px;*/
/*    color: #969799;*/
/*    font-size: 18px;*/
/*    background-color: #fff;*/
/*    border-radius: 100%;*/
/*}*/

.fd-name-type {
  width: 100%;
  height: 50px;
  background: #fff;
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  line-height: 50px;

  > span {
    font-size: 14px;
    color: #333;
  }

  .fd-right-icon {
    font-size: 18px;
    margin-top: 16px;
    color: #969799;
  }
}
.delete-btn {
  width: 64px;
  height: 55px;
  background: #ee0a24;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  letter-spacing: 3px;
  text-align: center;
}
</style>
